import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import store from '@/store'
import LoginCode from '../views/LoginCode.vue'
import Counterparts from '../views/Counterparts/Counterparts.vue'
import AddCounterpart from '../views/Counterparts/AddCounterpart.vue'
import EditCounterpartDetails from '../views/Counterparts/EditCounterpartDetails.vue'
import BillingParameters from '../views/Counterparts/BillingParameters.vue'
import AddBillingParameter from '../views/Counterparts/AddBillingParameter.vue'
import BillingKinds from '../views/Billing/BillingKinds/BillingKinds.vue'
import AddBillingKind from '../views/Billing/BillingKinds/AddBillingKind.vue'
import GetBillingKind from '../views/Billing/BillingKinds/GetBillingKind.vue'
import BillingColumns from '../views/Billing/BillingColumns/BillingColumns.vue'
import AddBillingColumn from '../views/Billing/BillingColumns/AddBillingColumn.vue'
import EditBillingParameter from '../views/Counterparts/EditBillingParameter.vue'
import BillParameterHistory from '../views/Counterparts/BillParameterHistory.vue'
import Verification from '../reports/Verification.vue'
import VerificationResultsDisplaying from '../reports/VerificationResultsDisplaying.vue'
import VerificationDetails from '../reports/VerificationDetails.vue'
import IncidentRecords from '../views/RequestsDirectory/Incidents/IncidentRecords.vue'
import IncidentRecord from '../views/RequestsDirectory/Incidents/IncidentRecord.vue'
import ReservesRecords from '../reports/ReservesRecords.vue'
import BillingChangesList from '../reports/BillingChangesList.vue'
import BillingChangeHistory from '../reports/BillingChangeHistory.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/error',
		component: () => import('../views/Error.vue')
	},
	{
		path: '/login',
		meta: { layout: 'empty' },
		component: Login
	},
	{
		path: '/login/code',
		meta: { layout: 'empty' },
		component: LoginCode
	},
	{
		path: '/',
		redirect: '/carQueue'
	},
	// регистрация
	{
		path: '/carQueue',
		meta: { layout: 'main', auth: true },
		component: () => import('../views/CarQueue/CarQueue.vue')
	},
	// редактирование регистрации
	{
		path: '/carQueueItem/:id?',
		props: true,
		meta: { layout: 'main', auth: true, deny: ['Клиент'] },
		component: () => import('../views/CarQueue/CarQueueItem.vue')
	},
	// текущая ситуация
	{
		path: '/carRequests',
		meta: { layout: 'main', auth: true, deny: ['Регистратор'] },
		component: () => import('../views/CarRequests/CarRequests.vue')
	},
	// товары
	{
		path: '/goods',
		meta: { layout: 'main', auth: true, deny: ['Регистратор'] },
		component: () => import('../views/GoodsDirectory/Goods.vue')
	},
	// заявки
	{
		path: '/requests',
		meta: { layout: 'main', auth: true, deny: ['Регистратор'] },
		component: () => import('../views/RequestsDirectory/Requests.vue')
	},
	{
		path: '/request/:id?',
		props: true,
		meta: { layout: 'main', auth: true, deny: ['Регистратор'] },
		component: () => import('../views/RequestsDirectory/Request.vue')
	},
	// пользователи
	{
		path: '/users',
		meta: { layout: 'main', auth: true, allow: ['Администратор'] }, // разрешено ролям Администратор
		component: () => import('../views/Users/Users.vue')
	},
	{
		path: '/settings/cargoTypes/editDetails/:cargoTypeID',
		meta: { layout: 'main', auth: true, allow: ['Администратор', 'Управляющий'] },
		name: 'EditCounterpartDetails',
		props: true, // This will pass route params as props
		component: EditCounterpartDetails
	},
	{
		path: '/settings/cargoTypes/BillingParameters/:cargoTypeID',
		meta: { layout: 'main', auth: true, allow: ['Администратор', 'Управляющий'] },
		name: 'BillingParameters',
		props: true, // This will pass route params as props
		component: BillingParameters
	},
	{
		path: '/settings/cargoTypes/BillingParameters/:cargoTypeID/add',
		meta: { layout: 'main', auth: true, allow: ['Администратор', 'Управляющий'] },
		name: 'AddBillingParameter',
		props: true, // This will pass route params as props
		component: AddBillingParameter
	},
	{
		path: '/settings/cargoTypes/BillingParameters/update/:id',
		meta: { layout: 'main', auth: true, allow: ['Администратор', 'Управляющий'] },
		name: 'EditBillingParameter',
		props: true, // This will pass route params as props
		component: EditBillingParameter
	},
	{
		path: '/settings/cargoTypes/add',
		meta: { layout: 'main', auth: true, allow: ['Администратор', 'Управляющий'] },
		name: 'AddCounterpart',
		component: AddCounterpart
	},
	{
		path: '/settings/cargoTypes',
		meta: { layout: 'main', auth: true, allow: ['Администратор', 'Управляющий'] },
		name: 'Counterparts',
		component: Counterparts
	},
	{
		path: '/settings/billingVids',
		meta: { layout: 'main', auth: true, allow: ['Администратор', 'Управляющий'] },
		name: 'BillingKinds',
		component: BillingKinds
	},
	{
		path: '/settings/billingVids/add',
		meta: { layout: 'main', auth: true, allow: ['Администратор', 'Управляющий'] },
		name: 'AddBillingKind',
		component: AddBillingKind
	},
	{
		path: '/settings/billingVids/get/:id',
		meta: { layout: 'main', auth: true, allow: ['Администратор', 'Управляющий'] },
		name: 'GetBillingKind',
		component: GetBillingKind
	},
	{
		path: '/settings/billingColumns',
		meta: { layout: 'main', auth: true, allow: ['Администратор', 'Управляющий'] },
		name: 'BillingColumns',
		component: BillingColumns
	},
	{
		path: '/settings/billingColumns/add',
		meta: { layout: 'main', auth: true, allow: ['Администратор', 'Управляющий'] },
		name: 'AddBillingColumn',
		component: AddBillingColumn
	},
	{
		path: '/settings/billingParameters/:idColumn/:cargoTypeId/history',
		meta: { layout: 'main', auth: true, allow: ['Администратор', 'Управляющий'] },
		name: 'BillParameterHistory',
		component: BillParameterHistory
	},
	{
		path: '/reports/verification',
		meta: { layout: 'main', auth: true, allow: ['Администратор', 'Управляющий'] },
		name: 'Verification',
		component: Verification
	},
	{
		path: '/reports/VerificationResultsDisplaying',
		meta: { layout: 'main', auth: true, allow: ['Администратор', 'Управляющий'] },
		name: 'VerificationResultsDisplaying',
		component: VerificationResultsDisplaying
	},
	{
		path: '/reports/VerificationDetails',
		meta: { layout: 'main', auth: true, allow: ['Администратор', 'Управляющий'] },
		name: 'VerificationDetails',
		component: VerificationDetails
	},
	{
		path: '/incident-records',
		meta: { layout: 'main', auth: true, allowedUsers: [10, 20, 23, 45] },
		name: 'IncidentRecords',
		component: IncidentRecords
	},
	{
		path: '/incident-records/:id',
		meta: { layout: 'main', auth: true, allowedUsers: [10, 20, 23, 45] },
		name: 'IncidentRecord',
		component: IncidentRecord
	},
	{
		path: '/reserves-records',
		meta: { layout: 'main', auth: true, allowedUsers: [10, 20, 23, 45] },
		name: 'ReservesRecords',
		component: ReservesRecords
	},
	// Маршруты для изменений в биллинге
	// Маршруты для биллинга
	{
		path: '/billing-changes',
		name: 'BillingChangesList',
		component: BillingChangesList,
		meta: {
        	layout: 'main', 
			title: 'Изменения в биллинге',
			requiresAuth: true
		}
	},
	{
		path: '/billing-changes/add',
		name: 'AddBillingChange',
		component: () => import('@/reports/BillingChangeForm.vue'),
		meta: {
        	layout: 'main', 
			title: 'Добавление изменения',
			requiresAuth: true
		}
	},
	{
		path: '/billing-changes/edit/:id',
		name: 'EditBillingChange',
		component: () => import('@/reports/BillingChangeForm.vue'),
		meta: {
        	layout: 'main', 
			title: 'Редактирование изменения',
			requiresAuth: true
		}
	},
	{
		path: '/billing-changes/history/:id',
		name: 'BillingChangeHistory',
		component: BillingChangeHistory,
		meta: {
        	layout: 'main', 
			title: 'История изменений',
			requiresAuth: true
		}
	},
	// 404
	{
		path: '*',
		component: () => import('../views/Error.vue')
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach((to, from, next) => {
    const authRequired = to.matched.some(x => x.meta.auth)
    if (!authRequired) {
        next()
        return
    }

	// если токен пропал -> рестор из хранилища
	if (!store.state.auth.token) {
		store.dispatch('auth/restoreToken')
	}
	// в хранилище токена нет - логин
	if (!store.state.auth.token) {
		next(`/login?from=${to.fullPath}`)
		return
	}

	// если пользователь уже есть - роутим его
	if (store.state.auth.user) {
		routeRole(to, next)
		return
	}
	// нет пользователя - загружаем его данные: login, role
	store.dispatch('auth/setUser')
		.then(() => {
			// всё равно роутим
			routeRole(to, next)
		})
		.catch(() => {
			// если не смогли загрузить пользователя - логин
			next(`/login?from=${to.fullPath}`)
		})
})

// роут пользователя на основе его роли
// если юзер не имеет права посещения страницы по роли, то путь идёт на главную
function routeRole(to, next) {
    const user = store.state.auth.user;
    if (!user) {
        next('/');
        return;
    }

    const userRole = user.role;
    const userId = parseInt(user.userID || user.id || 0);
    
    // Проверка по конкретным пользователям
    const hasAllowedUsers = to.matched.some(x => x.meta.allowedUsers);
    if (hasAllowedUsers) {
        const isAllowed = to.matched
            .filter(x => x.meta.allowedUsers)
            .some(x => x.meta.allowedUsers.includes(userId));
        
        if (!isAllowed) {
            next('/');
            return;
        }
    }
    
    // Проверка по ролям (allow)
    const hasAllow = to.matched.some(x => x.meta.allow);
    if (hasAllow) {
        const isAllowed = to.matched
            .filter(x => x.meta.allow)
            .every(x => x.meta.allow.includes(userRole));
        
        if (!isAllowed) {
            next('/');
            return;
        }
    }
    
    // Проверка по deny
    const hasDeny = to.matched.some(x => x.meta.deny);
    if (hasDeny) {
        const isDenied = to.matched
            .filter(x => x.meta.deny)
            .some(x => x.meta.deny.includes(userRole));
        
        if (isDenied) {
            next('/');
            return;
        }
    }
    
    next()
}

// доступность маршрута для пользователя
router.isRouteAllowed = (r) => {
    let route = r
    if (!r.path) { 
        route = router.options.routes.find(x => x.path === r) 
    }

    const user = store.state.auth.user
    if (!user) {
        return false;
    }

    const userId = parseInt(user.userID)
    const userRole = user.role

    // 1. Проверка по конкретным пользователям (allowedUsers)
    if (route?.meta?.allowedUsers) {
        const isUserAllowed = route.meta.allowedUsers.includes(userId)

		// Если есть еще и allow, проверяем оба (OR логика)
        if (route.meta.allow) {
            const isRoleAllowed = route.meta.allow.includes(userRole)
            return isUserAllowed || isRoleAllowed
        }
        return isUserAllowed
    }

    // 2. Проверка по ролям (allow)
    if (route?.meta?.allow) {
        const isRoleAllowed = route.meta.allow.includes(userRole)
        return isRoleAllowed
    }
    
    // 3. Проверка по запрету ролей (deny)
    if (route?.meta?.deny) {
        const isDenied = route.meta.deny.includes(userRole)
        return !isDenied
    }
    return true
}

export default router
